<template>
  <el-col :span="18" class="content-right" v-loading="loading">
    <!-- :type="tradeType" -->
    <tradeOrderList ref="tradeOrderList" :orderList="orderList" :queryParams="queryParams" @handleFilter="getAllList"></tradeOrderList>
    <div class="pagination">
      <el-pagination
        v-if="orderList.length !== 0"
        background
        :total="total"
        layout="total, prev, pager, next"
        :current-page="queryParams.page"
        :page-size="queryParams.pageSize"
        @current-change="handleCurrentChange"
      />
    </div>
  </el-col>
</template>

<script>
import tradeOrderList from './components/trade-order-list.vue'
import { localStorageUtils } from '@/utils/localstorage'
export default {
  name: 'AllOrder',
  components: {
    tradeOrderList
  },
  data () {
    return {
      loading: false,
      total: null,
      orderList: [],
      tradeType: '',
      queryParams: {
        execTypeSub: '',
        approvalType: '',
        page: 1,
        pageSize: 10,
        applyType: '',
        verifyStatus: '', // 审批类型/订单状态
        applyStatus: '',
        solutionStatus: '',
        acceptanceStatus: '',
        requirementStatus: '',
        executionStatus: '',
        isOwner: '',
        pledgePaid: '',
        applyClientLevel: '',
        queryType: '',
        queryRegionCode: '',
        queryBuCode: '',
        tradeStackWeek: '',
        tradeStackWeekStatus: '',
        waitClockIn: '',
        stackSpecs: '',
        applyNumber: '',
        vendorName: '',
        pocName: '',
        pocCode: '',
        execType: '',
        isAll: '',
        keyword: '',
        orderCol: '',
        orderMethod: '',
        applyTypeTemp: '',
        applyStatusTemp: '',
        queryStatus: '',
        clientType: '',
        waitSupplement: ''
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'bcc-order-info') {
      localStorageUtils.set('bccApproveQueryParams', JSON.stringify(this.queryParams))
    } else {
      localStorageUtils.remove('bccApproveQueryParams')
    }
    next()
  },

  watch: {
    '$route': {
      handler (to, from) {
        this.queryParams.page = 1
        this.getQueryParams()
      },
      immediate: true
    }
  },
  methods: {
    getQueryParams () {
      if (localStorageUtils.get('bccApproveQueryParams')) {
        this.queryParams = JSON.parse(localStorageUtils.get('bccApproveQueryParams'))
        this.$nextTick(() => {
          this.$refs.tradeOrderList.showStatus()
        })
      }
      this.getAllList()
      localStorageUtils.remove('bccApproveQueryParams')
    },
    // 获取待审批订单
    getAllList () {
      this.queryParams.queryType = '000'
      this.loading = true
      this.$store
        .dispatch('getSeekQuatation', this.queryParams)
        .then((response) => {
          if (response.data.resultCode === '0') {
            // console.log(response.data,'获取待审批订单');
            this.orderList = response.data.resultData.tradeApplyList || []
            this.total = response.data.resultData.pageInfo.totalCounts
          }
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    handleCurrentChange (val) {
      this.queryParams.page = val
      // if (this.tradeType === "all" || this.tradeType === "closed") {
      this.getAllList()
      // } else if (
      //   this.tradeType === "waitApprove" ||
      //   this.tradeType === "waitCheck" ||
      //   this.tradeType === "waitAccept"
      // ) {
      //   this.getApproveList();
      // }
    }
  }
}
</script>

<style lang="scss" scoped>
.pagination .el-pagination {
  text-align: center;
}
</style>
